var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonObject, JsonProperty, OnDeserialized } from 'ta-json-x';
let Thing = class Thing {
    _OnDeserialized() {
        // tslint:disable-line
        /* istanbul ignore next */
        if (!this.name) {
            console.log('Required [Thing.Name] is not set!');
        }
    }
};
__decorate([
    JsonProperty('name'),
    __metadata("design:type", Object)
], Thing.prototype, "name", void 0);
__decorate([
    JsonProperty('identifier'),
    __metadata("design:type", String)
], Thing.prototype, "identifier", void 0);
__decorate([
    JsonProperty('sortAs'),
    __metadata("design:type", String)
], Thing.prototype, "sortAs", void 0);
__decorate([
    OnDeserialized(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Thing.prototype, "_OnDeserialized", null);
Thing = __decorate([
    JsonObject()
], Thing);
export { Thing };
//# sourceMappingURL=thing.js.map